import { Badge, Card, CardContent, EmptyState, Skeleton } from '@estac1/ui';
import { ChevronDown, ChevronRight, History } from 'lucide-react';
import type { AuditEntry } from './types.js';
import { formatAt } from './utils.js';

interface PricingHistoryCardProps {
  auditLoading: boolean;
  pricingHistory: AuditEntry[];
  expandedHistory: Set<string>;
  onToggleHistory: (id: string) => void;
}

export const PricingHistoryCard = ({
  auditLoading,
  pricingHistory,
  expandedHistory,
  onToggleHistory,
}: PricingHistoryCardProps) => (
  <Card>
    <CardContent className="space-y-3 pt-6">
      <div className="flex items-center gap-2">
        <History className="h-4 w-4 text-muted-fg" />
        <h3 className="text-sm font-semibold">Histórico de alterações</h3>
      </div>
      {auditLoading ? (
        <Skeleton className="h-20 w-full" />
      ) : pricingHistory.length === 0 ? (
        <EmptyState
          icon={<History className="h-5 w-5" />}
          title="Sem alterações ainda"
          description="Quando alguém salvar os preços, aparece aqui."
        />
      ) : (
        <ul className="space-y-2">
          {pricingHistory.map((entry) => {
            const canExpand =
              entry.diff !== null &&
              entry.diff !== undefined &&
              !(typeof entry.diff === 'object' && Object.keys(entry.diff).length === 0);
            const isOpen = expandedHistory.has(entry.id);
            return (
              <li key={entry.id} className="rounded border border-border bg-surface text-sm">
                <button
                  type="button"
                  className="flex w-full flex-wrap items-baseline justify-between gap-2 px-3 py-2 text-left disabled:cursor-default"
                  onClick={() => canExpand && onToggleHistory(entry.id)}
                  disabled={!canExpand}
                >
                  <span className="flex items-center gap-2">
                    {canExpand ? (
                      isOpen ? (
                        <ChevronDown className="h-3 w-3" />
                      ) : (
                        <ChevronRight className="h-3 w-3" />
                      )
                    ) : (
                      <span className="inline-block w-3" />
                    )}
                    <span className="font-medium">{entry.actorEmail ?? 'sistema'}</span>
                  </span>
                  <span className="font-mono text-xs text-muted-fg">{formatAt(entry.at)}</span>
                  <Badge variant="outline" className="font-mono text-xs">
                    {entry.action}
                  </Badge>
                </button>
                {isOpen && canExpand && (
                  <pre className="overflow-x-auto whitespace-pre-wrap break-all border-t border-border bg-muted/40 p-3 font-mono text-xs">
                    {JSON.stringify(entry.diff, null, 2)}
                  </pre>
                )}
              </li>
            );
          })}
        </ul>
      )}
    </CardContent>
  </Card>
);
